//Document ready
$(document).ready(function () {
	baselineGrid();
	matchHeightBulk();
	preventDefaultClick();
	slickInit();
	slickHpSliderInit();
	scrollUpInit();
	languageToggle();
	styleSelectInit();
	$(".page-banner").paroller();


});

//Resize
$(window).resize(function () {});

//Functions

//Match height bulk
function matchHeightBulk() {
	$(".service-heading").matchHeight();
	$(".vehicle-block .article-heading").matchHeight();
}

//Baseline Grid
function baselineGrid() {
	var gridToggle = $(".baseline-toggle");

	gridToggle.click(function () {
		$("html").toggleClass("js-baseline");
	});
}

//Prevent  defaault on click
function preventDefaultClick() {
	$(".prevent-def").click(function (e) {
		e.preventDefault();
	});
}

//Slick init
function slickInit() {
	var icoSrc = $(".vehicle-carousel").attr("data-ico-path");

	$(".vehicle-carousel").slick({
		infinite: false,
		slidesToShow: 5,
		prevArrow: '<div class="slick-prev"><img src="' + icoSrc + '" alt=""></div>',
		nextArrow: '<div class="slick-next"><img src="' + icoSrc + '" alt=""></div>',
		lazyLoad: "progressive",

		responsive: [{
				breakpoint: 992,
				settings: {
					slidesToShow: 4
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 450,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	$(".vehicle-carousel").css("opacity", "1");
}

function slickHpSliderInit() {
	var icoSrc = $(".hp-slider-slick").attr("data-ico-path");
	$('.hp-slider-slick').slick({
		dots: true,
		fade: true,
		lazyLoad: 'progressive',
		autoplay: true,
		autoplaySpeed: 6000,
		prevArrow: '<div class="slick-prev"><img src="' + icoSrc + '" alt=""></div>',
		nextArrow: '<div class="slick-next"><img src="' + icoSrc + '" alt=""></div>',
	});
}

//Scroll Up button Init
function scrollUpInit() {
	$(window).scroll(function () {
		if ($(this).scrollTop() > 100) {
			$(".btn-scrollup").addClass("btn-scrollup-show");
		} else {
			$(".btn-scrollup").removeClass("btn-scrollup-show");
		}
	});

	$(".btn-scrollup").click(function () {
		$("html, body").animate({
				scrollTop: 0
			},
			700
		);
		return false;
	});
}

//Language select toggle
function languageToggle() {
	$(".header-lang-current").click(function (e) {
		e.stopPropagation();

		if ($(".header-lang-all").hasClass('header-lang-all-open')) {
			$(".header-lang-all").removeClass('header-lang-all-open');
		} else {

			$(".header-lang-all").addClass('header-lang-all-open');
		}
	});

	$(document.body).click(function (e) {
		$(".header-lang-all").removeClass('header-lang-all-open');
	});

	$(".header-lang-all").click(function (e) {
		e.stopPropagation();
	});

}

//StyleSelect init
function styleSelectInit() {
	if ($("select").length) {
		styleSelect("select");
	}
}

/* Media query template
if (window.matchMedia("(max-width: 41em)").matches) {
}
*/